import React, { useEffect, useRef, useState } from "react";
import { useGlobal } from "../../global/user";
import { Machine, Image } from "../../api";
import { Modal, Form, Input, InputNumber, Switch } from "antd";

export default function EditModal({ setMachines, machine, onEdit, setOnEdit}) {
  const { user } = useGlobal();
  const [deviceType, setDeviceType] = useState(0);
  const [form] = Form.useForm();
  const onUploadImage = async (e) => {
    const response = await Image.UploadImage(e.target.files[0]);
    form.setFieldsValue({ image: response });
  };
  const InputRef = useRef();
  const clearFile = () => {
    InputRef.current.value = null;
  };
  const onSubmit = () => {
    const { IP, name, port, socket_port, fake_update, image } = form.getFieldsValue();
    setMachines((machines) => {
      let newMachines = [...machines];
      return newMachines.map((element) => {
        if (element.id === machine.id) {
          element.IP = IP;
          element.mobile_name = name;
          element.port = port;
          element.socket_port = socket_port;
          element.fake_update = fake_update;
          element.image = image;
        }
        return element;
      });
    });
    (async () => {
      let res = await Machine.EditProfile({
        id: machine.id,
        IP,
        name,
        port,
        socket_port,
        fake_update: fake_update ? 1 : 0,
        image,
      });
      if (res.code !== 200) alert("更新失敗 (伺服器有誤)");
    })();
    clearFile();
    setOnEdit(false);
  };
  const formItemLayout = {
    labelCol: {
      sm: {
        span: 4,
      },
    },
    wrapperCol: {
      sm: {
        span: 18,
      },
    },
  };
  useEffect(() => {
    if (onEdit && machine) {
      const { id, mobile_name, port, socket_port, fake_update, image, IP } = machine;
      const MachineObject = {
        id,
        name: mobile_name,
        IP,
        port,
        socket_port,
        fake_update,
        image,
      };
      form.setFieldsValue(MachineObject);
      setDeviceType(machine.mobileType_id || 0);
    }
  }, [onEdit, machine, form]);
  return (
    <Modal
      open={onEdit}
      title="編輯機具資訊"
      onOk={() => form.submit()}
      onCancel={() => {
        setOnEdit(false);
        clearFile();
      }}
    >
      <Form form={form} {...formItemLayout} onFinish={onSubmit}>
        <Form.Item name="name" label="名稱" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="IP" label="IP位址">
          <Input />
        </Form.Item>
        <Form.Item
          name="port"
          label="通訊埠"
          rules={
              deviceType == 3 || deviceType == 8 || deviceType == 9 || deviceType == 10 || deviceType == 11 || deviceType == 12
                ? []
                : [
                    {
                      required: true,
                      message: "請輸入通訊埠為1~65535的數字",
                    },
                    {
                      type: "number",
                      max: 65535,
                      min: 1,
                      message: "請輸入通訊埠為1~65535的數字",
                    },
                  ]
            }
        >
          <InputNumber />
        </Form.Item>
        <Form.Item
          name="socket_port"
          label="機具埠"
          rules={
              deviceType == 3 || deviceType == 8 || deviceType == 9 || deviceType == 10 || deviceType == 11 || deviceType == 12
                ? []
                : [
                    {
                      required: true,
                      message: "請輸入機具埠為1~65535的數字",
                    },
                    {
                      type: "number",
                      max: 65535,
                      min: 1,
                      message: "請輸入機具埠為1~65535的數字",
                    },
                  ]
            }
        >
          <InputNumber />
        </Form.Item>
        <Form.Item hidden={user.name != "WebManager"} name="fake_update" label="偽更新">
          <Switch checkedChildren="開啟" unCheckedChildren="關閉" defaultChecked={machine.fake_update}/>
        </Form.Item>
        <Form.Item name="image" label="相片/影片">
          <Input />
        </Form.Item>
      </Form>
      <div className="control_form">
        <span className="control_text" />
        <div className="input_group" onChange={onUploadImage}>
          <input
            ref={InputRef}
            type="file"
            id="img"
            name="img"
            accept="image/*,video/*"
          />
        </div>
      </div>
    </Modal>
  );
}
